<br />

<div>
  <br />
</div>
<footer class="footer-wrapper">
  <div class="footer-wrapper__inside">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <div class="footer-copyright">
            <p>
              <span>
                <!-- © 2025 -->
                {{ "customer_footer.copyright" | translate }}
              </span>
            </p>
          </div>
        </div>
        <div class="col-md-6">
          <div class="footer-menu text-end">
            <ul>
              <li>
                <a href="/faq">
                  <!-- FAQ -->
                  {{ "customer_footer.links.faq" | translate }}
                </a>
              </li>
              <li>
                <a href="/terms_of_use">
                  <!-- Terms of Use -->
                  {{ "customer_footer.links.terms" | translate }}
                </a>
              </li>
              <li>
                <a href="/privacy_policy">
                  <!-- Privacy Policy -->
                  {{ "customer_footer.links.privacy" | translate }}
                </a>
              </li>
              <li>
                <a href="/cookie_policy">
                  <!-- Cookie Policy -->
                  {{ "customer_footer.links.cookie" | translate }}
                </a>
              </li>
            </ul>
          </div>
          <!-- ends: .Footer Menu -->
        </div>
      </div>
    </div>
  </div>
</footer>
